import React from 'react';
import axios from 'axios';
import {toast} from 'react-toastify';
import store, {history} from './store'
import {logout, adminLogout} from "./actions/login"
import {check, clear} from "./utils/tokenUtils"
import {getAuthorizationToken} from './utils/tokenUtils'
import ToastMessage from './components/common/toast-message'

const BASE_URL = '/';
// const BASE_URL = 'http://34.251.147.232';

let token = getAuthorizationToken();
if(token) {
  if(check()){
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    logout();
    window.location.pathname = 'login';
  }
}

const irelandApi = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Accept': 'application/json',
  }
});
function loginNeeded(){
  const preLogins = ['/login', '/registration/about-you', '/admin/welcome']
  return !(preLogins.indexOf(window.location.pathname) > -1)
}

irelandApi.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if(error.response.status === 401 &&
     loginNeeded() &&
     !window.location.pathname.startsWith('/password-reset-link/')){
    clear();
    toast.error(<ToastMessage iconStyle="error"
                              message="You do not have access to this page. Please log in to view"/>);
    store.dispatch(adminLogout()).then(() => store.dispatch(logout()).then(() => history.push('/login')));
  }
  return Promise.reject(error);
});

irelandApi.mock = (url, payLoad = null, time = 1000) => new Promise(resolve => setTimeout(resolve, time));


export default irelandApi;



// WEBPACK FOOTER //
// ./src/irelandApi.js